
<div class="Section FAQ" id="faq">
    <SiteFAQ
        :faqs="faqs"
        title="Alles was Sie wissen müssen"
        subtitle="Beantwortet in unseren FAQs"
        theme="light"
    />
</div>
